import React, { Component } from "react";
import Image from "react-bootstrap/Image";
import { NavLink } from "react-router-dom";
import Alert from "react-s-alert";
import RightSidePannel from "../rightSidePannelReusable/RightSidePannel";
import { TopTextReusableComponent } from "../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Form from "react-bootstrap/Form";
import {
  ReusableOnboardingLink,
  ReusableOnboardingButton,
  ReusableOnboardingMapButton,
} from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import SuggestNewButton from "../../reusableOnboardingPopupComponent/suggestNew/SuggestNewButton";
import isEmpty from "../../../../store/validation/is-Empty";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import { SliderReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import Media from "react-media";
import { MobileTopHeader } from "../../../reusableComponents/sliderReusableComponent/MobileTopHeader";

export class PetsAllowedComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actionButton: false,
      selectedTab: 2,
      all_pets_allowed_icons: [],
      selected_pet_allowance: [],
      primary_pet_allowance: {},
    };
  }

  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: true,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.onboarding._id) &&
      !isEmpty(nextProps.pets) &&
      !nextState.hasSetMapProps
    ) {
      let selected_pet_allowance = nextProps.onboarding.selected_pet_allowance;
      let primary_pet_allowance = nextProps.onboarding.primary_pet_allowance;
      if (
        !isEmpty(nextProps.onboarding.primary_pet_allowance) &&
        !isEmpty(selected_pet_allowance[0])
      ) {
        if (
          nextProps.onboarding.primary_pet_allowance !== "" &&
          isEmpty(selected_pet_allowance[0]._id) &&
          selected_pet_allowance.length > 0 &&
          isEmpty(primary_pet_allowance._id)
        ) {
          selected_pet_allowance = nextProps.pets.filter((pet) =>
            selected_pet_allowance.includes(pet._id)
          );
          primary_pet_allowance = nextProps.pets.filter(
            (pet) => pet._id === primary_pet_allowance
          )[0];
        }
      }
      let all_pets = nextProps.pets.filter(
        (pet) =>
          !selected_pet_allowance.some(
            (selected) => selected._id === pet._id
          ) && pet.status !== "NOTAPPROVED"
      );
      return {
        all_pets_allowed_icons: all_pets,
        selected_pet_allowance: !isEmpty(selected_pet_allowance)
          ? selected_pet_allowance
          : [],
        primary_pet_allowance: !isEmpty(primary_pet_allowance)
          ? primary_pet_allowance
          : {},
        hasSetMapProps: true,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }
  /****************************************
   * @DESC - Payment Method SELECTOR
   ****************************************/
  onRestaurantSelectorArraySelector = (icon, index) => (e) => {
    let buttonArray = this.state.all_pets_allowed_icons;
    let Restaurant = this.state.selected_pet_allowance;
    let primaryIcon = this.state.primary_pet_allowance;
    if (icon.title === "No Pets Allowed" && Restaurant.length >= 1) {
      Alert.error("<h4>Cannot select this option</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 5000,
        offset: 30,
      });
    } else if (primaryIcon.title == "No Pets Allowed") {
      Alert.error("<h4>No Pets Allowed Already Selected</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 5000,
        offset: 30,
      });
    } else {
      buttonArray.splice(index, 1);
      if (Restaurant.length === 0 || primaryIcon === {}) {
        Restaurant.push(icon);
        this.setState({
          selected_pet_allowance: Restaurant,
          primary_pet_allowance: icon,
          actionButton: true,
        });
      } else {
        let isAlreadyPresent = Restaurant.includes(icon);
        if (isAlreadyPresent) {
          let indexOf = Restaurant.indexOf(icon);
          if (indexOf === 0 || indexOf) {
            Restaurant.splice(indexOf, 1);
          }
        } else {
          Restaurant.push(icon);
        }
      }
      this.setState({
        selected_pet_allowance: Restaurant,
        actionButton: true,
      });
    }
  };

  onRestaurantsPrimarySelector = (icon) => (e) => {
    this.setState({
      primary_pet_allowance: icon,
      actionButton: true,
    });
  };

  /****************************************
   * @DESC - Remove Primary button handler
   ****************************************/
  removeButton = (icon) => (e) => {
    let {
      all_pets_allowed_icons,
      selected_pet_allowance,
      primary_pet_allowance,
    } = this.state;

    let iconIndexAtAllIcons = all_pets_allowed_icons.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons = selected_pet_allowance.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconAtPrimaryIcon =
      !isEmpty(primary_pet_allowance) && primary_pet_allowance._id === icon._id
        ? true
        : false;
    if (selected_pet_allowance.length === 0) {
      selected_pet_allowance.push(icon);
      all_pets_allowed_icons.splice(iconIndexAtAllIcons, 1);
      primary_pet_allowance = icon;
    } else if (iconAtPrimaryIcon) {
      selected_pet_allowance.splice(iconIndexAtSelectedIcons, 1);
      all_pets_allowed_icons.push(icon);
      if (selected_pet_allowance.length === 1) {
        primary_pet_allowance = selected_pet_allowance[0];
      } else {
        primary_pet_allowance = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_pet_allowance.splice(iconIndexAtSelectedIcons, 1);
      all_pets_allowed_icons.push(icon);
      if (selected_pet_allowance.length === 1) {
        primary_pet_allowance = selected_pet_allowance[0];
      }
    } else {
      selected_pet_allowance.push(icon);
      all_pets_allowed_icons.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_pet_allowance: selected_pet_allowance,
      all_pets_allowed_icons: all_pets_allowed_icons,
      primary_pet_allowance: primary_pet_allowance,
      actionButton: true,
    });
  };

  onWithOutApiCall = (e) => {
    this.props.history.push({
      pathname: "/dresscodetype",
    });
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    if (
      this.props.onboarding &&
      this.props.onboarding.selected_pet_allowance.length > 0
    ) {
      const formData = {
        vendor_id: this.props.onboarding.vendor_id,
        id: this.props.onboarding._id,
        selected_pet_allowance: this.state.selected_pet_allowance,
        primary_pet_allowance: this.state.primary_pet_allowance,
      };
      this.props.create_and_update_restaurant(formData);
      this.props.history.push("/dresscodetype");
    } else {
      const formData = {
        vendor_id: this.props.onboarding.vendor_id,
        id: this.props.onboarding._id,
        selected_pet_allowance: this.state.selected_pet_allowance,
        primary_pet_allowance: this.state.primary_pet_allowance,
        page_completed_till: 9,
      };
      this.props.create_and_update_restaurant(formData);
      this.props.history.push("/dresscodetype");
    }
  };

  renderDressCodeFields = () => {
    const {
      actionButton,
      selected_pet_allowance,
      primary_pet_allowance,
      all_pets_allowed_icons,
    } = this.state;
    return (
      <React.Fragment>
        <div className="restaurant_type_onboarding_main">
          <div className="margin-bottom-chains-onboarding">
            <div className="cuisine-main ">
              <div
                className={
                  all_pets_allowed_icons.length > 8
                    ? "cuisine-main-padding-border"
                    : ""
                }
              >
                <div
                  id="box-style"
                  className="cuisine-main-padding justify-content-start column-2"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {all_pets_allowed_icons.map((icon, index) => (
                    <ReusableOnboardingMapButton
                      key={index}
                      classsection="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                      src={icon.icon}
                      title={icon.title}
                      onClick={this.onRestaurantSelectorArraySelector(
                        icon,
                        index
                      )}
                    />
                  ))}
                </div>
              </div>
              <div className="suggest-button-heading">
                <SuggestNewButton categoryId={"5f562c9094ac7fdf47ea1d0d"} />
              </div>

              {/** */}
              {!isEmpty(selected_pet_allowance) ? (
                <React.Fragment>
                  <div className="f14-500 mt-4">
                    Out of the selections below, which one is primary?
                  </div>
                  <div className="f11-400 opacity5">
                    Select only one of the options below as a default - this is
                    shown to the user.
                  </div>
                </React.Fragment>
              ) : null}

              <div
                className="cuisine-main-padding-bottom justify-content-start column-2 mt-4"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {selected_pet_allowance.map((icon, index) => (
                  <ReusableOnboardingMapButton
                    key={index}
                    classsection={
                      // icon._id === primary_pet_allowance._id
                      //   ?
                      "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type"
                      // : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                    }
                    src={icon.icon}
                    title={icon.title}
                    onClick={this.onRestaurantsPrimarySelector(icon)}
                    displayPrimary={
                      icon._id === primary_pet_allowance._id ? true : false
                    }
                    displayRemove={true}
                    removeButtonClick={this.removeButton(icon)}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="onboarding-map-setup-screen-autodetect-button">
            {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
            <ReusableOnboardingLink
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Back"
              link="/parking"
            />
            <ReusableOnboardingButton
              buttonTitle="Next Button"
              buttonClass={
                selected_pet_allowance.length <= 0 ||
                isEmpty(primary_pet_allowance._id)
                  ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                  : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
              }
              disabled={
                selected_pet_allowance.length <= 0 ||
                isEmpty(primary_pet_allowance._id)
                  ? true
                  : false
              }
              buttonText="Next"
              onClick={actionButton === false ? this.onWithOutApiCall : null}
              buttonType={actionButton === false ? "button" : "submit"}
            />
            {/* </div> */}
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    if (this.state.loader) {
      return <AmealioLoader />;
    }
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div
              id="onboarding-scrollbar"
              className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left"
            >
              {/* <div className="col-12 onboarding_process_screen_left-backbutton">
                <NavLink to="/parking" className="back_button-link">
                  <Image
                    src={require("../../../../assets/images/Icon/onBoardBack.png")}
                    alt="Back Button"
                    title="Back Button"
                  />
                </NavLink>
              </div> */}
              <Media query="(min-width: 992px)">
                <div className="col-12">
                  <BackLogoIconButton
                    displayBackText={true}
                    displayArrow={true}
                    backButtonClicked={"/parking"}
                  />
                </div>
              </Media>
              <Media query="(max-width: 991px)">
                <MobileTopHeader link={true} onLink={"/parking"} />
              </Media>
              {/* <div className="display-toggle-stepup-button">
                <RightSidePannel selectedTab={this.state.selectedTab} />
              </div> */}
              <div className="onboarding_process_screen-button-map">
                {/* <MapSetupScreenTwo /> */}
                <div>
                  <TopTextReusableComponent
                    headingText="Pets Allowed"
                    headingParagraph="If your place has pets restrictions, you can select them here if there are no restrictions then you can select 'All pets allowed' If your place has pets restrictions, you can select them here to be displayed on user app."
                  />
                </div>
                <Form noValidate onSubmit={this.onHandleSubmit}>
                  {this.renderDressCodeFields()}
                </Form>
              </div>
            </div>
            <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
              <SliderReusableComponent
                displayBarButton={true}
                displayHamburger={true}
                selectedProgressBarOne="active"
                paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-06.svg")}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  pets: state.category.pet_allowance_type,
});

export default connect(mapStateToProps, { create_and_update_restaurant })(
  withRouter(PetsAllowedComponent)
);
